module.exports = __webpack_public_path__ + "img/truck-orange.ab07f393.svg";